// import type { Id } from 'flowTypes/common';
import { prepareAndMakeRequest } from '@frontend/api';

import request from 'utils/request';

// export type Roles = {|
//   accounting: string,
//   integrations: string,
//   analytics: string,
//   customers: string,
//   digiquoteSettings: string,
//   orders: string,
//   processes: string,
//   quotes: string,
//   supplierSettings: string,
//   team: string,
// |};

// export type TeamMember = {|
//   id: ?Id,
//   email: string,
//   firstName: string,
//   isAdmin: ?boolean,
//   jobTitle: string,
//   erpCode: string,
//   lastName: string,
//   supplierRoles: Roles,
//   userId: ?Id,
// |};

const transformTeamMemberToApi = (member) => {
  if (member.isAdmin || !member.supplierRoles) member.supplierRoles = undefined;
  return member;
};

export default {
  invites: {
    resend: async (groupId, data) => {
      return await request.post(`/users/groups/${groupId}/resend_invite`, data);
    },
  },
  getTeamMembers: async (groupId, params) => {
    return await prepareAndMakeRequest.get(`/suppliers/${groupId}/members`, {
      query: params,
    });
  },
  getTeamMember: async (memberId) => {
    return await request.get(`/suppliers/members/${memberId}`);
  },
  deleteTeamMember: async (memberId) => {
    return await request.delete(`/suppliers/members/${memberId}`);
  },
  inviteTeamMember: async (groupId, data) => {
    return await request.post(
      `/users/groups/${groupId}/send_invite`,
      transformTeamMemberToApi(data),
    );
  },
  updateTeamMember: async (memberId, data) => {
    return await request.patch(
      `/suppliers/members/${memberId}`,
      transformTeamMemberToApi(data),
    );
  },
  sendVerificationEmail: async (id) => {
    return await request.post(`/users/${id}/send_ses_verification_request`);
  },
  getIsEmailVerified: async (id) => {
    const response = await request.get(`/users/${id}/ses_verification_status`);
    return response && response.verifiedInAwsSes;
  },
};
